import KPICards from '../Components/KPICards';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import {
  kpiApData,
  settlementTrendData,
  apAgingData,
} from '../Data/mockData';

export default function Ap() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>

      {/* KPI Cards */}
      <div>
        <h2
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: '#111827',
            marginBottom: 16,
          }}
        >
          Accounts Payable Overview
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 16,
          }}
        >
          {kpiApData.map((kpi, index) => (
            <KPICards
              key={index}
              label={kpi.label}
              value={kpi.value}
              trend={kpi.trend}
              bgColor={kpi.bgColor}
            />
          ))}
        </div>
      </div>

      {/* Settlement Performance */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
        }}
      >
        {/* Line Chart */}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 8,
            border: '1px solid #e5e7eb',
            padding: 24,
          }}
        >
          <h2
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: '#111827',
              marginBottom: 16,
            }}
          >
            Settlement Time Trend
          </h2>

          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={settlementTrendData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Line
                type="monotone"
                dataKey="avgDays"
                stroke="#8b5cf6"
                strokeWidth={2}
                name="Avg Settlement Days"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Bar Chart */}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 8,
            border: '1px solid #e5e7eb',
            padding: 24,
          }}
        >
          <h2
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: '#111827',
              marginBottom: 16,
            }}
          >
            Paid vs Pending by Month
          </h2>

          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={settlementTrendData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                formatter={(value) =>
                  `AED ${(value / 1000000).toFixed(1)}M`
                }
              />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="paid" fill="#10b981" name="Paid" />
              <Bar dataKey="pending" fill="#f59e0b" name="Pending" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* AP Aging */}
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 8,
          border: '1px solid #e5e7eb',
          padding: 24,
        }}
      >
        <h2
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: '#111827',
            marginBottom: 16,
          }}
        >
          AP Aging Analysis
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {apAgingData.map((item, index) => {
            const barColor =
              index === 0
                ? '#22c55e'
                : index === 1
                ? '#3b82f6'
                : index === 2
                ? '#f97316'
                : '#ef4444';

            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                }}
              >
                <div
                  style={{
                    width: 128,
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#374151',
                  }}
                >
                  {item.bucket}
                </div>

                <div
                  style={{
                    flex: 1,
                    backgroundColor: '#f3f4f6',
                    borderRadius: 9999,
                    height: 40,
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0 16px',
                      backgroundColor: barColor,
                      width: `${(item.amount / 15200000) * 100}%`,
                      minWidth: 150,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#ffffff',
                      }}
                    >
                      AED {(item.amount / 1000000).toFixed(1)}M
                    </span>

                    <span
                      style={{
                        fontSize: 12,
                        color: 'rgba(255,255,255,0.9)',
                      }}
                    >
                      {item.count} invoices
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    width: 96,
                    textAlign: 'right',
                    fontSize: 14,
                    color: '#4b5563',
                  }}
                >
                  {((item.amount / 21700000) * 100).toFixed(1)}%
                </div>
              </div>
            );
          })}
        </div>

        {/* Summary Cards */}
        <div
          style={{
            marginTop: 24,
            paddingTop: 24,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 16,
          }}
        >
          <div
            style={{
              backgroundColor: '#ecfdf5',
              borderRadius: 8,
              padding: 16,
            }}
          >
            <div style={{ fontSize: 12, color: '#4b5563', marginBottom: 4 }}>
              Current (0-30 days)
            </div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: '#15803d',
              }}
            >
              AED 15.2M
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
              70% of total AP
            </div>
          </div>

          <div
            style={{
              backgroundColor: '#fff7ed',
              borderRadius: 8,
              padding: 16,
            }}
          >
            <div style={{ fontSize: 12, color: '#4b5563', marginBottom: 4 }}>
              Overdue (31-60 days)
            </div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: '#c2410c',
              }}
            >
              AED 4.8M
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
              22% of total AP
            </div>
          </div>

          <div
            style={{
              backgroundColor: '#fef2f2',
              borderRadius: 8,
              padding: 16,
            }}
          >
            <div style={{ fontSize: 12, color: '#4b5563', marginBottom: 4 }}>
              Critical (60+ days)
            </div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: '#b91c1c',
              }}
            >
              AED 1.7M
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
              8% of total AP
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
